import * as i0 from '@angular/core';
import { Injectable, Component, Input, ChangeDetectionStrategy, HostBinding, ViewEncapsulation } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import * as i2 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1$1 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
const _c0 = a0 => ({
  width: a0
});
const _c1 = ["*"];
function BtnComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function BtnComponent_button_2_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.icon)("fontSet", "material-icons-round");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.icon, " ");
  }
}
function BtnComponent_button_2_ng_template_2_Template(rf, ctx) {}
function BtnComponent_button_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BtnComponent_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵtemplate(1, BtnComponent_button_2_mat_icon_1_Template, 2, 3, "mat-icon", 6)(2, BtnComponent_button_2_ng_template_2_Template, 0, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(4, BtnComponent_button_2_ng_container_4_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const buttonContent_r2 = i0.ɵɵreference(1);
    i0.ɵɵclassMap("button " + ctx_r0.buttonStyle);
    i0.ɵɵclassProp("thin", ctx_r0.thin)("tiny", ctx_r0.tiny)("hasWidth", ctx_r0.width);
    i0.ɵɵproperty("id", ctx_r0.id)("ngStyle", i0.ɵɵpureFunction1(12, _c0, ctx_r0.width));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.icon);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", buttonContent_r2);
  }
}
function BtnComponent_ng_template_3_Conditional_0_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.icon)("fontSet", "material-icons-round");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.icon, " ");
  }
}
function BtnComponent_ng_template_3_Conditional_0_ng_template_2_Template(rf, ctx) {}
function BtnComponent_ng_template_3_Conditional_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BtnComponent_ng_template_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵtemplate(1, BtnComponent_ng_template_3_Conditional_0_mat_icon_1_Template, 2, 3, "mat-icon", 6)(2, BtnComponent_ng_template_3_Conditional_0_ng_template_2_Template, 0, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(4, BtnComponent_ng_template_3_Conditional_0_ng_container_4_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const buttonContent_r2 = i0.ɵɵreference(1);
    i0.ɵɵclassMap("button " + ctx_r0.buttonStyle);
    i0.ɵɵclassProp("hasWidth", ctx_r0.width);
    i0.ɵɵproperty("id", ctx_r0.id)("routerLink", ctx_r0.link)("ngStyle", i0.ɵɵpureFunction1(10, _c0, ctx_r0.width))("target", ctx_r0.openInNewTab ? "_blank" : "_self");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.icon);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", buttonContent_r2);
  }
}
function BtnComponent_ng_template_3_Conditional_1_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.icon)("fontSet", "material-icons-round");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.icon, " ");
  }
}
function BtnComponent_ng_template_3_Conditional_1_ng_template_2_Template(rf, ctx) {}
function BtnComponent_ng_template_3_Conditional_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BtnComponent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵtemplate(1, BtnComponent_ng_template_3_Conditional_1_mat_icon_1_Template, 2, 3, "mat-icon", 6)(2, BtnComponent_ng_template_3_Conditional_1_ng_template_2_Template, 0, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(4, BtnComponent_ng_template_3_Conditional_1_ng_container_4_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const buttonContent_r2 = i0.ɵɵreference(1);
    i0.ɵɵclassMap("button " + ctx_r0.buttonStyle);
    i0.ɵɵclassProp("hasWidth", ctx_r0.width);
    i0.ɵɵproperty("href", ctx_r0.link, i0.ɵɵsanitizeUrl)("ngStyle", i0.ɵɵpureFunction1(9, _c0, ctx_r0.width))("target", ctx_r0.openInNewTab ? "_blank" : "_self");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.icon);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", buttonContent_r2);
  }
}
function BtnComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BtnComponent_ng_template_3_Conditional_0_Template, 5, 12, "a", 9)(1, BtnComponent_ng_template_3_Conditional_1_Template, 5, 11, "a", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.internalRedirect ? 0 : 1);
  }
}
const _c2 = [[["", "help", ""]]];
const _c3 = ["[help]"];
function HelpButtonComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function HelpButtonComponent_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showModal());
    });
    i0.ɵɵelementEnd();
  }
}
function HelpButtonComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("--modal-width", ctx_r1.modalWidth);
    i0.ɵɵproperty("ngClass", ctx_r1.expandTo);
  }
}
let ComponentsService = /*#__PURE__*/(() => {
  class ComponentsService {
    constructor() {}
    static ɵfac = function ComponentsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ComponentsService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ComponentsService,
      factory: ComponentsService.ɵfac,
      providedIn: 'root'
    });
  }
  return ComponentsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ComponentsComponent = /*#__PURE__*/(() => {
  class ComponentsComponent {
    static ɵfac = function ComponentsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ComponentsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ComponentsComponent,
      selectors: [["lib-components"]],
      decls: 2,
      vars: 0,
      template: function ComponentsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "p");
          i0.ɵɵtext(1, " components works! ");
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return ComponentsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconComponent = /*#__PURE__*/(() => {
  class IconComponent {
    icon;
    size = '32px';
    static ɵfac = function IconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IconComponent,
      selectors: [["cl-icon"]],
      inputs: {
        icon: "icon",
        size: "size"
      },
      decls: 1,
      vars: 5,
      consts: [["aria-hidden", "true", 3, "alt", "ngStyle", "src"]],
      template: function IconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "img", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("alt", ctx.icon)("ngStyle", i0.ɵɵpureFunction1(3, _c0, ctx.size))("src", "/assets/icons/" + ctx.icon + ".svg", i0.ɵɵsanitizeUrl);
        }
      },
      dependencies: [CommonModule, i1.NgStyle],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return IconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Icon = /*#__PURE__*/function (Icon) {
  Icon["alert"] = "alert";
  Icon["book"] = "book";
  Icon["radioAntenna"] = "radio-antenna";
  Icon["puzzle"] = "puzzle";
  Icon["target"] = "target";
  Icon["question"] = "question";
  Icon["warning"] = "warning";
  Icon["user"] = "user";
  Icon["trophy"] = "trophy";
  Icon["students"] = "students";
  Icon["speedometer"] = "speedometer";
  Icon["school"] = "school";
  Icon["scale"] = "scale";
  Icon["numberBlocks"] = "number-blocks";
  Icon["keyLabel"] = "key-label";
  Icon["flowchart"] = "flowchart";
  Icon["chart"] = "chart";
  Icon["calculator"] = "calculator";
  Icon["blackboard"] = "blackboard";
  Icon["report"] = "report";
  Icon["activityDesigner"] = "activity-designer";
  Icon["assessmentDesigner"] = "assessment-designer";
  Icon["emailOpen"] = "email-open";
  Icon["email"] = "email";
  Icon["house"] = "house";
  Icon["menu"] = "menu";
  Icon["pageFirst"] = "page-first";
  Icon["pagePrevious"] = "page-previous";
  Icon["pageNext"] = "page-next";
  Icon["pageLast"] = "page-last";
  Icon["info"] = "info";
  Icon["cancel"] = "cancel";
  Icon["reunion"] = "reunion";
  Icon["music"] = "music";
  Icon["fitness"] = "fitness";
  Icon["manual"] = "manual";
  Icon["growth"] = "growth";
  Icon["checkbox"] = "check-box";
  Icon["placement"] = "placement";
  Icon["weeklyProgress"] = "weekly-progress";
  Icon["weeklyScores"] = "weekly-scores";
  Icon["calendar"] = "calendar";
  Icon["form"] = "form-icon";
  Icon["chevron"] = "chevron-right";
  Icon["customized"] = "customized";
  Icon["training"] = "training";
  Icon["configure"] = "configure";
  Icon["goalLine"] = "goal-line";
  Icon["repeat"] = "repeat";
  Icon["add"] = "add";
  Icon["dashboards"] = "dashboards";
  Icon["upstartCode"] = "upstart-code";
  Icon["usage"] = "stopwatch";
  Icon["usageBoth"] = "usage-both";
  Icon["calendarWhite"] = "calendar-white";
  Icon["locked"] = "locked";
  Icon["unlocked"] = "unlocked";
  Icon["incognito"] = "incognito";
  Icon["download"] = "download";
  Icon["move"] = "move";
  Icon["plus"] = "plus";
  Icon["qrCode"] = "qr-code";
  Icon["revert"] = "revert";
  Icon["trashRed"] = "trash-red";
  Icon["userStars"] = "user-stars";
  Icon["scaleZoom"] = "scale-zoom";
  Icon["programs"] = "programs-icon";
  Icon["sortAscending"] = "sortAscending";
  Icon["sortDescending"] = "sortDescending";
  Icon["link"] = "link";
  Icon["starFull"] = "star-full";
  Icon["starEmpty"] = "star-empty";
  Icon["campConsonant"] = "camp-consonant";
  Icon["checkmark"] = "checkmark";
  Icon["bellBlue"] = "bell-blue";
  Icon["bellRed"] = "bell-red";
  Icon["back"] = "back";
  Icon["forward"] = "forward";
  Icon["arrowRight"] = "arrow-right";
  Icon["volume"] = "volume";
  Icon["pause"] = "pause";
  Icon["curriculetBook"] = "curriculet-book";
  Icon["laptop"] = "laptop";
  Icon["pdf"] = "pdf";
  Icon["video"] = "video";
  Icon["reading"] = "reading-icon";
  Icon["weeklyReading"] = "weekly-reading";
  Icon["assignBooks"] = "book-multiple";
  Icon["masteryScores"] = "mastery-scores";
  Icon["playlist"] = "playlist";
  Icon["visible"] = "visible";
  Icon["notVisible"] = "not-visible";
  Icon["fail"] = "fail";
  Icon["settingsBlue"] = "settings";
  Icon["settingsRed"] = "setting";
  Icon["filtersFunnel"] = "filters-funnel";
  Icon["menuTabs"] = "menu-tabs";
  Icon["logoutBlue"] = "logout-blue";
  Icon["logoutRed"] = "logout";
  Icon["share"] = "share";
  Icon["save"] = "save";
  Icon["start"] = "start";
  Icon["stop"] = "stop";
  Icon["grabber"] = "reorder-grabber";
  Icon["downArrow"] = "down-arrow";
  Icon["resetPassword"] = "password-lock";
  Icon["edit"] = "edit";
  Icon["metadata"] = "metadata";
  Icon["chechboxEmpty"] = "checkbox-empty";
  Icon["newStar"] = "new-star";
  Icon["checklistMenu"] = "checklistMenu";
  Icon["lightBulb"] = "light-bulb";
  Icon["activityReport"] = "activity-report";
  Icon["createThumbnail"] = "create-thumbnail";
  Icon["pauseCircle"] = "pause-circle";
  Icon["restart"] = "restart";
  Icon["supportIcon"] = "support-icon";
  Icon["search"] = "search";
  Icon["key"] = "key";
  Icon["families"] = "families";
  Icon["export"] = "export";
  Icon["usersCircle"] = "users-circle";
  Icon["telephone"] = "telephone";
  return Icon;
}(Icon || {});
let BtnComponent = /*#__PURE__*/(() => {
  class BtnComponent {
    icon;
    size;
    width;
    buttonStyle = 'primary';
    disabled = false;
    thin = false;
    tiny = false;
    link;
    id = '';
    openInNewTab = false;
    internalRedirect = false;
    static ɵfac = function BtnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BtnComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BtnComponent,
      selectors: [["cl-btn"]],
      hostVars: 2,
      hostBindings: function BtnComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("disabled", ctx.disabled);
        }
      },
      inputs: {
        icon: "icon",
        size: "size",
        width: "width",
        buttonStyle: "buttonStyle",
        disabled: "disabled",
        thin: "thin",
        tiny: "tiny",
        link: "link",
        id: "id",
        openInNewTab: "openInNewTab",
        internalRedirect: "internalRedirect"
      },
      ngContentSelectors: _c1,
      decls: 5,
      vars: 2,
      consts: [["buttonContent", ""], ["linkTmp", ""], ["empty", ""], [3, "class", "id", "thin", "tiny", "hasWidth", "ngStyle", 4, "ngIf", "ngIfElse"], [1, "button-text"], [3, "id", "ngStyle"], ["class", "icon", 3, "ngClass", "fontSet", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "icon", 3, "ngClass", "fontSet"], [3, "class", "id", "hasWidth", "routerLink", "ngStyle", "target"], [3, "class", "hasWidth", "href", "ngStyle", "target"], [3, "id", "routerLink", "ngStyle", "target"], [3, "href", "ngStyle", "target"]],
      template: function BtnComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, BtnComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, BtnComponent_button_2_Template, 5, 14, "button", 3)(3, BtnComponent_ng_template_3_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const linkTmp_r3 = i0.ɵɵreference(4);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.link)("ngIfElse", linkTmp_r3);
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, RouterLink, MatIcon],
      styles: ["[_ngcontent-%COMP%]:root{--primary: #1B5365;--primary-hover: #1B5365;--secondary: #3095B4;--secondary-hover: #3095B4;--text-color: #1B5365;--link-color: #3095B4;--link-color-hover: #1B5365;--primary-button-bg: #3095B4;--primary-button-bg-hover: #4ab0cf;--primary-button-bg-active: #339FC0;--primary-dark-button-bg: #1B5365;--primary-dark-button-hover: #3095B4;--primary-dark-button-active: #339FC0;--secondary-button-bg: #FFFFFF;--secondary-button-bg-hover: #4ab0cf;--secondary-button-bg-active: #339FC0;--red-button-bg: #F2403F;--red-button-bg-hover: #F45857;--red-button-bg-active: #D93838;--green-button-bg: #00C77E;--green-button-bg-hover: #00AE6E;--green-button-bg-active: #009E64;--detail-btn-hover:#DFF3FF;--success: #00C77E;--error: #F2403F;--black: #000000;--off-black: #333333;--white: #FFFFFF;--light-gray: #F2F2F2;--light-gray-variant: #E6E6E6;--gray: #999999;--dark-gray: #51626F;--background: #1B5365;--nav-item-bg: #3095B4;--nav-item-bg-hover: #339FC0;--nav-item-bg-active: #4ab0cf;--nav-button-bg: #3095B4;--nav-button-bg-hover: #4ab0cf;--upstart-background: #F2F2F2;--upstart-nav-item-bg: #E6E6E6;--upstart-nav-item-bg-hover: #EEEEEE;--upstart-nav-item-bg-active: #cccccc;--font-family: \"Fira Sans\", Arial, Helvetica, sans-serif;--new-font-family: \"Waterford No 3\", Arial, Helvetica, sans-serif;--header1: 3rem;--header2: 2rem;--header3: 1.75rem;--header4: 1.25rem;--header5: .875rem;--weight-slim: 300;--weight-regular: 400;--weight-book: 500;--weight-semibold: 600;--weight-bold: 700;--weight-extrabold: 900;--font-size-12: .75rem;--font-size-13: .8rem;--font-size-14: .875rem;--font-size-15: .9rem;--font-size-16: 1rem;--font-size-18: 1.125rem;--font-size-22: 1.375rem;--font-size-24: 1.5rem;--font-size-26: 1.625rem;--font-size-28: 1.75rem;--font-size-32: 2rem;--button-padding: .75em 1.25em;--button-thin-padding: .25em 1.25em;--button-tiny-padding: .25em .75em;--card-header-padding: .5rem 1.375rem;--card-small-header-padding: .375rem .75rem;--card-content-padding: .75rem 1rem;--border-none: 0 none;--border-1-black: 1px solid #000000;--border-1-white: 1px solid #FFFFFF;--border-5-white: 5px solid #FFFFFF;--border-1-bluemine: 1px solid #1B5365;--border-2-bluemine: 2px solid #1B5365;--border-1-boston-blue: 1px solid #3095B4;--border-1-shuttle-gray: 1px solid #51626F;--border-1-silver-dark: 1px solid #C4C4C4;--border-1-silver-light: 1px solid #B3B3B3;--border-2-mercury: 2px solid #E6E6E6;--border-radius-full: 100%;--border-radius-card: .625rem;--border-radius-card-title: .375rem .375rem 0 0;--border-radius-card-small-title: .9rem .9rem 0 0;--border-radius-card-content: .6rem;--border-radius-10: .625rem;--border-radius-20: 1.25rem;--border-radius-small-card: 1.125rem;--border-radius-btn: 2rem;--modal-box-shadow: 0 0 16px 0 rgba(0, 0, 0, .2);--element-hover-color: rgba(48, 149, 180, .3);--input-height: 35px;--input-color: #3095B4;--input-bg: #CFF2FC;--input-border: 1px solid #3095B4;--input-invalid-bg: #FFCAC6;--chart-green: #099760;--chart-light-green: #00C77E;--chart-red: #F2403F;--chart-blue: #3095B4;--chart-light-blue: #47C1E5;--chart-dark-blue: #1B5365;--chart-pink: #C15F91;--chart-orange: #F16D00;--chart-yellow: #F7A432;--chart-gray: #51626F;--chart-light-gray: #E6E6E6;--goals-upstart: #FF9999;--goals-smartstart: #FFD5D5;--goals-reading: #A8C0FC;--goals-ems: #A5E9FF;--goals-curriculet: #FFD5C2;--goals-wacs: #F1DDAB;--focus-blue: #1C667D;--standard: #4B7EFF;--reading: #848CBB;--smartstart: #DB7082;--math-and-science: #106985;--upstart: #C34D4D;--curriculet: #F76423;--assessment: #D58019;--awards: #A34FCB;--camp-consonant: #5FBCA6;--new-design-blue: #1B9AC2;--new-design-blue-2: #325CC7;--new-design-blue-3: #2B87A4;--new-design-blue-4: #0D5166;--new-design-green: #60B769;--new-design-green-2: #41AA4C;--new-design-orange: #BE5120;--new-design-purple: #A8C0FC;--new-design-pink: #FFD5C2;--new-design-white: #FFFFFF;--new-design-french-lilac: #E5CFF0;--z-index-max: 2147483647}@media (min-width: 480px){[_ngcontent-%COMP%]:root{--header1: 4rem;--header2: 2.5rem;--header3: 2rem;--header4: 1.5rem;--header5: 1rem}}.disabled[_nghost-%COMP%], [_nghost-%COMP%]:has(.disabled){pointer-events:none}.button[_ngcontent-%COMP%]{position:relative;display:inline-flex;color:var(--white);justify-content:center;align-items:center;border-radius:var(--border-radius-10);cursor:pointer;font-family:var(--font-family);font-size:var(--font-size-16);font-weight:var(--weight-regular);text-decoration:none;-webkit-user-select:none;user-select:none;width:inherit;height:44px;border:0 none;padding:.625rem .9375rem;gap:0 .75rem;overflow:hidden;transition:all .1s ease-in-out}.button[_ngcontent-%COMP%]:has(>span:empty){padding:.625rem;border-radius:var(--border-radius-full)}.button[_ngcontent-%COMP%]:has(>span:empty)   .icon[_ngcontent-%COMP%]{font-size:1.75rem}.button[_ngcontent-%COMP%]:has(>.icon){justify-content:flex-start}.button[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:empty{display:none}.button[_ngcontent-%COMP%]:hover{box-shadow:0 1px 3px 1px #3333334d}.button[_ngcontent-%COMP%]:focus, .button[_ngcontent-%COMP%]:focus-visible, .button[_ngcontent-%COMP%]:active{box-shadow:0 0 0 3px #0f86e380}.button.icon-right[_ngcontent-%COMP%]{flex-direction:row-reverse}.button[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;overflow:hidden;font-size:1.5rem;width:24px;height:24px}.button.primary[_ngcontent-%COMP%]{color:var(--white);background:var(--primary-button-bg)}.button.secondary[_ngcontent-%COMP%]{color:var(--secondary);background:var(--secondary-button-bg);border:1px solid var(--secondary)}.button.tertiary[_ngcontent-%COMP%]{color:var(--off-black);background:var(--tertiary-button-bg)}.button.tertiary[_ngcontent-%COMP%]:before{position:absolute;top:0;left:0;content:\"\";width:100%;height:100%;border-radius:var(--border-radius-10);box-shadow:0 0 0 1px var(--off-black) inset}.button.no-style[_ngcontent-%COMP%]{color:var(--secondary);background-color:var(--no-style-button-bg)}.button.alert[_ngcontent-%COMP%], .button.red[_ngcontent-%COMP%]{color:var(--white);background:var(--red-button-bg)}.button.small[_ngcontent-%COMP%]{height:32px;padding:.625rem .9375rem}.button.small[_ngcontent-%COMP%]:has(>span:empty){padding:.25rem}.button.small[_ngcontent-%COMP%]:has(>span:empty)   .icon[_ngcontent-%COMP%]{font-size:1.25rem}.button.disabled[_ngcontent-%COMP%]{pointer-events:none!important;cursor:not-allowed}.button.disabled[_ngcontent-%COMP%]:after{position:absolute;content:\"\";top:0;left:0;right:0;border-radius:var(--border-radius-10);background:#fff9;width:100%;height:100%}.button[_ngcontent-%COMP%]   .button-text[_ngcontent-%COMP%]{display:flex;align-items:center}.button.no-text[_ngcontent-%COMP%]{border:0}.button.no-text[_ngcontent-%COMP%]   .button-text[_ngcontent-%COMP%]{display:none}.button.hasWidth[_ngcontent-%COMP%]{justify-content:center}"],
      changeDetection: 0
    });
  }
  return BtnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HelpButtonComponent = /*#__PURE__*/(() => {
  class HelpButtonComponent {
    icon = Icon.question;
    flagModal = false;
    expandTo = 'right';
    modalWidth = '228px';
    showModal() {
      this.flagModal = !this.flagModal;
    }
    static ɵfac = function HelpButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HelpButtonComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HelpButtonComponent,
      selectors: [["cl-help-button"]],
      inputs: {
        icon: "icon",
        expandTo: "expandTo",
        modalWidth: "modalWidth"
      },
      ngContentSelectors: _c3,
      decls: 4,
      vars: 4,
      consts: [[1, "helpBtnContainer"], [3, "click", "icon", "size"], ["class", "helpBtnContainer__overlay", 3, "click", 4, "ngIf"], ["class", "helpBtnContainer__modal", 3, "ngClass", "--modal-width", 4, "ngIf"], [1, "helpBtnContainer__overlay", 3, "click"], [1, "helpBtnContainer__modal", 3, "ngClass"]],
      template: function HelpButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c2);
          i0.ɵɵelementStart(0, "div", 0)(1, "cl-icon", 1);
          i0.ɵɵlistener("click", function HelpButtonComponent_Template_cl_icon_click_1_listener() {
            return ctx.showModal();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, HelpButtonComponent_div_2_Template, 1, 0, "div", 2)(3, HelpButtonComponent_div_3_Template, 2, 3, "div", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("icon", ctx.icon)("size", "40px");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.flagModal);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.flagModal);
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.NgIf, IconComponent],
      styles: ["[_ngcontent-%COMP%]:root{--primary: #1B5365;--primary-hover: #1B5365;--secondary: #3095B4;--secondary-hover: #3095B4;--text-color: #1B5365;--link-color: #3095B4;--link-color-hover: #1B5365;--primary-button-bg: #3095B4;--primary-button-bg-hover: #4ab0cf;--primary-button-bg-active: #339FC0;--primary-dark-button-bg: #1B5365;--primary-dark-button-hover: #3095B4;--primary-dark-button-active: #339FC0;--secondary-button-bg: #FFFFFF;--secondary-button-bg-hover: #4ab0cf;--secondary-button-bg-active: #339FC0;--red-button-bg: #F2403F;--red-button-bg-hover: #F45857;--red-button-bg-active: #D93838;--green-button-bg: #00C77E;--green-button-bg-hover: #00AE6E;--green-button-bg-active: #009E64;--detail-btn-hover:#DFF3FF;--success: #00C77E;--error: #F2403F;--black: #000000;--off-black: #333333;--white: #FFFFFF;--light-gray: #F2F2F2;--light-gray-variant: #E6E6E6;--gray: #999999;--dark-gray: #51626F;--background: #1B5365;--nav-item-bg: #3095B4;--nav-item-bg-hover: #339FC0;--nav-item-bg-active: #4ab0cf;--nav-button-bg: #3095B4;--nav-button-bg-hover: #4ab0cf;--upstart-background: #F2F2F2;--upstart-nav-item-bg: #E6E6E6;--upstart-nav-item-bg-hover: #EEEEEE;--upstart-nav-item-bg-active: #cccccc;--font-family: \"Fira Sans\", Arial, Helvetica, sans-serif;--new-font-family: \"Waterford No 3\", Arial, Helvetica, sans-serif;--header1: 3rem;--header2: 2rem;--header3: 1.75rem;--header4: 1.25rem;--header5: .875rem;--weight-slim: 300;--weight-regular: 400;--weight-book: 500;--weight-semibold: 600;--weight-bold: 700;--weight-extrabold: 900;--font-size-12: .75rem;--font-size-13: .8rem;--font-size-14: .875rem;--font-size-15: .9rem;--font-size-16: 1rem;--font-size-18: 1.125rem;--font-size-22: 1.375rem;--font-size-24: 1.5rem;--font-size-26: 1.625rem;--font-size-28: 1.75rem;--font-size-32: 2rem;--button-padding: .75em 1.25em;--button-thin-padding: .25em 1.25em;--button-tiny-padding: .25em .75em;--card-header-padding: .5rem 1.375rem;--card-small-header-padding: .375rem .75rem;--card-content-padding: .75rem 1rem;--border-none: 0 none;--border-1-black: 1px solid #000000;--border-1-white: 1px solid #FFFFFF;--border-5-white: 5px solid #FFFFFF;--border-1-bluemine: 1px solid #1B5365;--border-2-bluemine: 2px solid #1B5365;--border-1-boston-blue: 1px solid #3095B4;--border-1-shuttle-gray: 1px solid #51626F;--border-1-silver-dark: 1px solid #C4C4C4;--border-1-silver-light: 1px solid #B3B3B3;--border-2-mercury: 2px solid #E6E6E6;--border-radius-full: 100%;--border-radius-card: .625rem;--border-radius-card-title: .375rem .375rem 0 0;--border-radius-card-small-title: .9rem .9rem 0 0;--border-radius-card-content: .6rem;--border-radius-10: .625rem;--border-radius-20: 1.25rem;--border-radius-small-card: 1.125rem;--border-radius-btn: 2rem;--modal-box-shadow: 0 0 16px 0 rgba(0, 0, 0, .2);--element-hover-color: rgba(48, 149, 180, .3);--input-height: 35px;--input-color: #3095B4;--input-bg: #CFF2FC;--input-border: 1px solid #3095B4;--input-invalid-bg: #FFCAC6;--chart-green: #099760;--chart-light-green: #00C77E;--chart-red: #F2403F;--chart-blue: #3095B4;--chart-light-blue: #47C1E5;--chart-dark-blue: #1B5365;--chart-pink: #C15F91;--chart-orange: #F16D00;--chart-yellow: #F7A432;--chart-gray: #51626F;--chart-light-gray: #E6E6E6;--goals-upstart: #FF9999;--goals-smartstart: #FFD5D5;--goals-reading: #A8C0FC;--goals-ems: #A5E9FF;--goals-curriculet: #FFD5C2;--goals-wacs: #F1DDAB;--focus-blue: #1C667D;--standard: #4B7EFF;--reading: #848CBB;--smartstart: #DB7082;--math-and-science: #106985;--upstart: #C34D4D;--curriculet: #F76423;--assessment: #D58019;--awards: #A34FCB;--camp-consonant: #5FBCA6;--new-design-blue: #1B9AC2;--new-design-blue-2: #325CC7;--new-design-blue-3: #2B87A4;--new-design-blue-4: #0D5166;--new-design-green: #60B769;--new-design-green-2: #41AA4C;--new-design-orange: #BE5120;--new-design-purple: #A8C0FC;--new-design-pink: #FFD5C2;--new-design-white: #FFFFFF;--new-design-french-lilac: #E5CFF0;--z-index-max: 2147483647}@media (min-width: 480px){[_ngcontent-%COMP%]:root{--header1: 4rem;--header2: 2.5rem;--header3: 2rem;--header4: 1.5rem;--header5: 1rem}}.helpBtnContainer[_ngcontent-%COMP%]{display:inline-block;position:relative;--modal-width: \"228px\"}.helpBtnContainer[_ngcontent-%COMP%]   cl-icon[_ngcontent-%COMP%]{border:var(--border-none);cursor:pointer;height:32px;width:32px;outline:none}.helpBtnContainer[_ngcontent-%COMP%]   cl-icon[_ngcontent-%COMP%]:hover{opacity:.85}.helpBtnContainer[_ngcontent-%COMP%]   cl-icon[_ngcontent-%COMP%]:focus, .helpBtnContainer[_ngcontent-%COMP%]   cl-icon[_ngcontent-%COMP%]:focus-visible, .helpBtnContainer[_ngcontent-%COMP%]   cl-icon[_ngcontent-%COMP%]:active{opacity:.7}.helpBtnContainer__overlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:1}.helpBtnContainer__modal[_ngcontent-%COMP%]{position:absolute;display:flex;padding:15px;border-radius:10px;background-color:#f2f2f2;width:var(--modal-width);border:var(--border-1-bluemine);font-family:var(--font-family);font-size:var(--font-size-14);line-height:16px;font-weight:var(--weight-regular);color:var(--text-color);z-index:2}.helpBtnContainer__modal[_ngcontent-%COMP%]:before{position:absolute;content:\"\"}.helpBtnContainer__modal.top[_ngcontent-%COMP%]{bottom:70px;right:0}.helpBtnContainer__modal.top[_ngcontent-%COMP%]:before{border-left:12px solid transparent;border-right:12px solid transparent;border-bottom:12px solid transparent;border-top:21px solid #1B5365;bottom:-33px;right:6px}.helpBtnContainer__modal.right[_ngcontent-%COMP%]{top:0;left:65px}.helpBtnContainer__modal.right[_ngcontent-%COMP%]:before{border-left:12px solid transparent;border-right:21px solid #1B5365;border-bottom:12px solid transparent;border-top:12px solid transparent;top:7px;left:-33px}.helpBtnContainer__modal.bottom[_ngcontent-%COMP%]{top:70px;right:0}.helpBtnContainer__modal.bottom[_ngcontent-%COMP%]:before{border-left:12px solid transparent;border-right:12px solid transparent;border-bottom:21px solid #1B5365;border-top:12px solid transparent;right:6px;top:-33px}.helpBtnContainer__modal.left[_ngcontent-%COMP%]{top:0;right:65px}.helpBtnContainer__modal.left[_ngcontent-%COMP%]:before{border-left:21px solid #1B5365;border-right:12px solid transparent;border-bottom:12px solid transparent;border-top:12px solid transparent;top:7px;right:-33px}@media (max-width: 811px){.helpBtnContainer__modal[_ngcontent-%COMP%]{right:0;top:auto;left:auto}.helpBtnContainer__modal.top[_ngcontent-%COMP%]:before{border-left:12px solid transparent;border-right:12px solid transparent;border-bottom:12px solid transparent;border-top:21px solid #1B5365;inset:auto 0 -33px auto}}"],
      changeDetection: 0
    });
  }
  return HelpButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DatePickerComponent = /*#__PURE__*/(() => {
  class DatePickerComponent {
    id;
    name;
    min;
    max;
    Icon = Icon;
    model;
    onTouched = () => {
      // nothing
    };
    // @ts-ignore
    onChange = _ => {
      // nothing
    };
    onInputChange() {
      const value = this.model;
      this.onChange(value);
    }
    onBlur() {
      this.onTouched();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnChange(fn) {
      this.onChange = fn;
    }
    writeValue(value) {
      if (value) {
        this.model = value;
      }
    }
    static ɵfac = function DatePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DatePickerComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DatePickerComponent,
      selectors: [["cl-date-picker"]],
      inputs: {
        id: "id",
        name: "name",
        min: "min",
        max: "max"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: DatePickerComponent,
        multi: true
      }])],
      decls: 5,
      vars: 7,
      consts: [["datePicker", ""], [1, "datepicker-wrap", 3, "click"], [3, "ngModelChange", "click", "blur", "id", "name", "ngModel", "matDatepicker", "min", "max"], ["size", "24px", 3, "icon"]],
      template: function DatePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("click", function DatePickerComponent_Template_div_click_0_listener() {
            i0.ɵɵrestoreView(_r1);
            const datePicker_r2 = i0.ɵɵreference(3);
            return i0.ɵɵresetView(datePicker_r2.open());
          });
          i0.ɵɵelementStart(1, "input", 2);
          i0.ɵɵtwoWayListener("ngModelChange", function DatePickerComponent_Template_input_ngModelChange_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.model, $event) || (ctx.model = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("click", function DatePickerComponent_Template_input_click_1_listener() {
            i0.ɵɵrestoreView(_r1);
            const datePicker_r2 = i0.ɵɵreference(3);
            return i0.ɵɵresetView(datePicker_r2.open());
          })("blur", function DatePickerComponent_Template_input_blur_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onBlur());
          })("ngModelChange", function DatePickerComponent_Template_input_ngModelChange_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onInputChange());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelement(2, "mat-datepicker", null, 0)(4, "cl-icon", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          const datePicker_r2 = i0.ɵɵreference(3);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx.id)("name", ctx.name);
          i0.ɵɵtwoWayProperty("ngModel", ctx.model);
          i0.ɵɵproperty("matDatepicker", datePicker_r2)("min", ctx.min)("max", ctx.max);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("icon", ctx.Icon.calendarWhite);
        }
      },
      dependencies: [CommonModule, MatDatepickerModule, i1$1.MatDatepicker, i1$1.MatDatepickerInput, MatNativeDateModule, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, IconComponent],
      styles: [":root{--primary: #1B5365;--primary-hover: #1B5365;--secondary: #3095B4;--secondary-hover: #3095B4;--text-color: #1B5365;--link-color: #3095B4;--link-color-hover: #1B5365;--primary-button-bg: #3095B4;--primary-button-bg-hover: #4ab0cf;--primary-button-bg-active: #339FC0;--primary-dark-button-bg: #1B5365;--primary-dark-button-hover: #3095B4;--primary-dark-button-active: #339FC0;--secondary-button-bg: #FFFFFF;--secondary-button-bg-hover: #4ab0cf;--secondary-button-bg-active: #339FC0;--red-button-bg: #F2403F;--red-button-bg-hover: #F45857;--red-button-bg-active: #D93838;--green-button-bg: #00C77E;--green-button-bg-hover: #00AE6E;--green-button-bg-active: #009E64;--detail-btn-hover:#DFF3FF;--success: #00C77E;--error: #F2403F;--black: #000000;--off-black: #333333;--white: #FFFFFF;--light-gray: #F2F2F2;--light-gray-variant: #E6E6E6;--gray: #999999;--dark-gray: #51626F;--background: #1B5365;--nav-item-bg: #3095B4;--nav-item-bg-hover: #339FC0;--nav-item-bg-active: #4ab0cf;--nav-button-bg: #3095B4;--nav-button-bg-hover: #4ab0cf;--upstart-background: #F2F2F2;--upstart-nav-item-bg: #E6E6E6;--upstart-nav-item-bg-hover: #EEEEEE;--upstart-nav-item-bg-active: #cccccc;--font-family: \"Fira Sans\", Arial, Helvetica, sans-serif;--new-font-family: \"Waterford No 3\", Arial, Helvetica, sans-serif;--header1: 3rem;--header2: 2rem;--header3: 1.75rem;--header4: 1.25rem;--header5: .875rem;--weight-slim: 300;--weight-regular: 400;--weight-book: 500;--weight-semibold: 600;--weight-bold: 700;--weight-extrabold: 900;--font-size-12: .75rem;--font-size-13: .8rem;--font-size-14: .875rem;--font-size-15: .9rem;--font-size-16: 1rem;--font-size-18: 1.125rem;--font-size-22: 1.375rem;--font-size-24: 1.5rem;--font-size-26: 1.625rem;--font-size-28: 1.75rem;--font-size-32: 2rem;--button-padding: .75em 1.25em;--button-thin-padding: .25em 1.25em;--button-tiny-padding: .25em .75em;--card-header-padding: .5rem 1.375rem;--card-small-header-padding: .375rem .75rem;--card-content-padding: .75rem 1rem;--border-none: 0 none;--border-1-black: 1px solid #000000;--border-1-white: 1px solid #FFFFFF;--border-5-white: 5px solid #FFFFFF;--border-1-bluemine: 1px solid #1B5365;--border-2-bluemine: 2px solid #1B5365;--border-1-boston-blue: 1px solid #3095B4;--border-1-shuttle-gray: 1px solid #51626F;--border-1-silver-dark: 1px solid #C4C4C4;--border-1-silver-light: 1px solid #B3B3B3;--border-2-mercury: 2px solid #E6E6E6;--border-radius-full: 100%;--border-radius-card: .625rem;--border-radius-card-title: .375rem .375rem 0 0;--border-radius-card-small-title: .9rem .9rem 0 0;--border-radius-card-content: .6rem;--border-radius-10: .625rem;--border-radius-20: 1.25rem;--border-radius-small-card: 1.125rem;--border-radius-btn: 2rem;--modal-box-shadow: 0 0 16px 0 rgba(0, 0, 0, .2);--element-hover-color: rgba(48, 149, 180, .3);--input-height: 35px;--input-color: #3095B4;--input-bg: #CFF2FC;--input-border: 1px solid #3095B4;--input-invalid-bg: #FFCAC6;--chart-green: #099760;--chart-light-green: #00C77E;--chart-red: #F2403F;--chart-blue: #3095B4;--chart-light-blue: #47C1E5;--chart-dark-blue: #1B5365;--chart-pink: #C15F91;--chart-orange: #F16D00;--chart-yellow: #F7A432;--chart-gray: #51626F;--chart-light-gray: #E6E6E6;--goals-upstart: #FF9999;--goals-smartstart: #FFD5D5;--goals-reading: #A8C0FC;--goals-ems: #A5E9FF;--goals-curriculet: #FFD5C2;--goals-wacs: #F1DDAB;--focus-blue: #1C667D;--standard: #4B7EFF;--reading: #848CBB;--smartstart: #DB7082;--math-and-science: #106985;--upstart: #C34D4D;--curriculet: #F76423;--assessment: #D58019;--awards: #A34FCB;--camp-consonant: #5FBCA6;--new-design-blue: #1B9AC2;--new-design-blue-2: #325CC7;--new-design-blue-3: #2B87A4;--new-design-blue-4: #0D5166;--new-design-green: #60B769;--new-design-green-2: #41AA4C;--new-design-orange: #BE5120;--new-design-purple: #A8C0FC;--new-design-pink: #FFD5C2;--new-design-white: #FFFFFF;--new-design-french-lilac: #E5CFF0;--z-index-max: 2147483647}@media (min-width: 480px){:root{--header1: 4rem;--header2: 2.5rem;--header3: 2rem;--header4: 1.5rem;--header5: 1rem}}.datepicker-wrap{position:relative;max-width:var(--weight-bold);height:35px}.datepicker-wrap[disabled]{opacity:.7;pointer-events:none}.datepicker-wrap cl-icon{position:absolute;right:0;background-color:var(--nav-button-bg);width:32px;height:35px;padding-left:4px;padding-top:5px;cursor:pointer;border-radius:0 10px 10px 0}.datepicker-wrap cl-icon:hover{opacity:.85}.datepicker-wrap cl-icon:focus,.datepicker-wrap cl-icon:focus-visible,.datepicker-wrap cl-icon:active{background:var(--primary)}.datepicker-wrap input{width:100%;height:35px;font-family:var(--font-family);padding:.5rem 1rem;font-size:1rem;color:#333;border:1px solid color-mix(in srgb,#333333 50%,transparent);border-radius:10px;background-color:var(--white);resize:none;transition:all .15s}.datepicker-wrap input:hover{box-shadow:0 1px 3px 1px color-mix(in srgb,#333333 30%,transparent)}.datepicker-wrap input:focus{outline:none;box-shadow:0 0 0 3px color-mix(in srgb,#0F86E3 50%,transparent);background:var(--white)}.datepicker-wrap input.ng-invalid{color:#ce394f;border:1px solid #CE394F;background-color:color-mix(in srgb,#CE394F 10%,transparent)}.datepicker-wrap input.ng-invalid:focus{border:0 none;background-color:var(--white);box-shadow:0 0 0 3px color-mix(in srgb,#CE394F 50%,transparent)}\n"],
      encapsulation: 2
    });
  }
  return DatePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FunctionalButtonComponent = /*#__PURE__*/(() => {
  class FunctionalButtonComponent {
    icon;
    size = '32px';
    disabled = false;
    id;
    static ɵfac = function FunctionalButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FunctionalButtonComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FunctionalButtonComponent,
      selectors: [["cl-functional-button"]],
      hostVars: 2,
      hostBindings: function FunctionalButtonComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("disabled", ctx.disabled);
        }
      },
      inputs: {
        icon: "icon",
        size: "size",
        disabled: "disabled",
        id: "id"
      },
      decls: 2,
      vars: 5,
      consts: [[3, "id"], [3, "icon", "size"]],
      template: function FunctionalButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵelement(1, "cl-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("disabled", ctx.disabled);
          i0.ɵɵproperty("id", ctx.id);
          i0.ɵɵadvance();
          i0.ɵɵproperty("icon", ctx.icon)("size", ctx.size);
        }
      },
      dependencies: [CommonModule, IconComponent],
      styles: [".disabled[_nghost-%COMP%]{pointer-events:none}a[_ngcontent-%COMP%]{display:inline-block;cursor:pointer;padding:5px;text-decoration:none;text-align:center;-webkit-user-select:none;user-select:none;width:inherit}a[_ngcontent-%COMP%]:hover{opacity:.85}a[_ngcontent-%COMP%]:focus, a[_ngcontent-%COMP%]:focus-visible, a[_ngcontent-%COMP%]:active{opacity:.7}a.disabled[_ngcontent-%COMP%]{opacity:.6;pointer-events:none}"],
      changeDetection: 0
    });
  }
  return FunctionalButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BtnComponent, ComponentsComponent, ComponentsService, DatePickerComponent, FunctionalButtonComponent, HelpButtonComponent, Icon, IconComponent };
